/**
 * vue-touch-keyboard v0.2.0
 * https://github.com/icebob/vue-touch-keyboard
 * Released under the MIT License.
 */
!(function (t, e) {
  typeof exports === 'object' && typeof module === 'object' ? module.exports = e() : typeof define === 'function' && define.amd ? define([], e) : typeof exports === 'object' ? exports.VueTouchKeyboard = e() : t.VueTouchKeyboard = e()
}(this, function () {
  return (function (t) {
    function e (r) {
      if (n[r]) return n[r].exports
      var o = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      }
      return t[r].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports
    }
    var n = {}
    return e.m = t, e.c = n, e.p = '', e(0)
  }([function (t, e, n) {
    'use strict'
    var r = n(1)
    t.exports = {
      component: r,
      layouts: n(73),
      install: function (t) {
        t.component('VueTouchKeyboard', r)
      }
    }
  }, function (t, e, n) {
    n(2)
    var r = n(3)(n(4), n(84), null, null)
    t.exports = r.exports
  }, function (t, e) {}, function (t, e) {
    t.exports = function (t, e, n, r) {
      var o; var i = t = t || {}
      var c = typeof t.default
      c !== 'object' && c !== 'function' || (o = t, i = t.default)
      var u = typeof i === 'function' ? i.options : i
      if (e && (u.render = e.render, u.staticRenderFns = e.staticRenderFns), n && (u._scopeId = n), r) {
        var s = Object.create(u.computed || null)
        Object.keys(r).forEach(function (t) {
          var e = r[t]
          s[t] = function () {
            return e
          }
        }), u.computed = s
      }
      return {
        esModule: o,
        exports: i,
        options: u
      }
    }
  }, function (t, e, n) {
    'use strict'

    function r (t) {
      return t && t.__esModule ? t : {
        default: t
      }
    }
    Object.defineProperty(e, '__esModule', {
      value: !0
    })
    var o = n(5)
    var i = r(o)
    var c = n(73)
    var u = r(c)
    var s = n(74)
    var f = r(s)
    var a = n(83)
    var l = r(a)
    e.default = {
      props: {
        input: HTMLInputElement,
        layout: [String, Object],
        accept: Function,
        cancel: Function,
        change: Function,
        next: Function,
        submit: Function,

        options: {
          type: Object,
          default: function () {
            return {}
          }
        }
      },
      data: function () {
        return {
          inputScrollLeft: 0,
          currentKeySet: this.getDefaultKeySet(false),
          initialKeySet: this.getDefaultKeySet(true)
        }
      },
      computed: {
        keySet: function p () {
          var t = this.getLayout()
          if (t) {
            var p = t[this.currentKeySet]
            if (p) {
              var e = []
              var n = t._meta || {}
              return p.forEach(function (t) {
                var r = []
                t.split(' ').forEach(function (t) {
                  if ((0, l.default)(t)) r.push(t)
                  else if ((0, f.default)(t)) {
                    if (t.length > 2 && t[0] == '{' && t[t.length - 1] == '}') {
                      var e = t.substring(1, t.length - 1)
                      n[e] ? r.push(n[e]) : console.warn('Missing named key from meta: ' + e)
                    } else {
                      t == '' ? r.push({
                        placeholder: !0
                      }) : r.push({
                        key: t,
                        text: t
                      })
                    }
                  }
                }), e.push(r)
              }), e
            }
          }
        }
      },
      watch: {
        layout: function () {
          this.currentKeySet = this.getDefaultKeySet(false)
          this.initialKeySet = this.getDefaultKeySet(true)
        },
        input: function () {
          this.currentKeySet = this.getDefaultKeySet(false)
          this.initialKeySet = this.getDefaultKeySet(true)
        }
      },
      methods: {
        getDefaultKeySet: function (initial) {
          var keyset = 'default'
          if (this.input.value.length > 0 && !initial) keyset = 'default'
          else if ((this.layout == 'default' || this.layout == 'submit' || this.layout == 'normal') && this.input.type == 'text') keyset = 'shifted'
          else keyset = 'default'
          return keyset
        },
        getLayout: function () {
          return (0, f.default)(this.layout) ? u.default[this.layout] : this.layout
        },
        changeKeySet: function (t) {
          var e = this.getLayout()
          e[t] != null && (this.currentKeySet = t)
        },
        toggleKeySet: function (t) {
          this.currentKeySet = this.currentKeySet == t ? 'default' : t
        },
        getCaptionOfKey: function (t) {
          return t.text || t.key || ''
        },
        getClassesOfKey: function (t) {
          if (t.placeholder) return 'placeholder'
          var e = 'key ' + (t.func || '') + ' ' + (t.classes || '')
          return t.keySet && this.currentKeySet == t.keySet && (e += ' activated'), e
        },
        getKeyStyle: function (t) {
          if (t.width) {
            return {
              flex: t.width
            }
          }
        },
        supportsSelection: function () {
          return /text|password|search|tel|url/.test(this.input.type)
        },
        getCaret: function () {
          if (this.supportsSelection()) {
            var t = {
              start: this.input.selectionStart || 0,
              end: this.input.selectionEnd || 0
            }
            return t.end < t.start && (t.end = t.start), t
          }
          var e = this.input.value
          return {
            start: e.length,
            end: e.length
          }
        },
        backspace: function (t, e) {
          var s = 1
          if (this.input.getAttribute('data-layout') == 'phone' || this.input.getAttribute('data-layout') == 'numeric') {
            var v = this.input.value
            var d = ['(', ')', '-', ' ']
            if (d.indexOf(e[e.length - 2]) >= 0) {
              s += 1
              if (d.indexOf(e[e.length - 3]) >= 0) {
                s += 1
              }
            }
          }
          if (e.length == 1) {
            this.currentKeySet = this.initialKeySet
          }
          return e = e.substring(0, t.start - s) + e.substring(t.start), t.start -= 1, t.end = t.start, e
        },
        backspaceCustom: function (t, e) {
          if (e.length == 1) {
            this.currentKeySet = this.initialKeySet
          }
          t.start = e.length
          t.end = e.length
          var s = 1
          if (this.input.getAttribute('data-layout') == 'phone' || this.input.getAttribute('data-layout') == 'numeric') {
            window.xxx = this.input
            var v = this.input.value
            var d = ['(', ')', '-', ' ']
            if (d.indexOf(e[e.length - 2]) >= 0) {
              s += 1
              if (d.indexOf(e[e.length - 3]) >= 0) {
                s += 1
              }
            }
          }
          if (e.length == 1) {
            this.currentKeySet = this.initialKeySet
          }
          return e = e.substring(0, t.start - s) + e.substring(t.start), t.start -= 1, t.end = t.start, e
        },
        insertChar: function (t, e, n) {
          return e = e.substr(0, t.start) + n.toString() + e.substr(t.start), t.start += n.length, t.end = t.start, e
        },
        mousedown: function () {
          this.input && (this.inputScrollLeft = this.input.scrollLeft)
        },
        clickKey: function (t) {
          if (this.input) {
            var e = this.getCaret()
            var n = this.input.value
            var r = null
            if ((typeof t === 'undefined' ? 'undefined' : (0, i.default)(t)) == 'object') {
              if (t.keySet) this.toggleKeySet(t.keySet)
              else if (t.func) {
                switch (t.func) {
                  case 'backspace':
                    n = this.backspace(e, n)
                    break
                  case 'backspace_custom':
                    n = this.backspaceCustom(e, n)
                    break
                  case 'accept':
                    return void (this.accept && this.accept(n))
                  case 'cancel':
                    return void (this.cancel && this.cancel())
                  case 'next':
                    return void (this.next && this.next())
                  case 'submit':
                    this.$emit('submit')
                    this.cancel()
                    return void (this.submit && this.submit())
                }
              } else r = t.key
            } else r = t
            if (r) {
              if (this.input.maxLength <= 0 || n.length < this.input.maxLength) {
                if (this.options.useKbEvents) {
                  var o = document.createEvent('Event')
                  o.initEvent('keypress', !0, !0), o.which = o.keyCode = r.charCodeAt(), this.input.dispatchEvent(o) && (n = this.insertChar(e, n, r))
                } else n = this.insertChar(e, n, r)
              }
              this.currentKeySet == 'shifted' && this.changeKeySet('default')
            }
            this.input.value = n, this.setFocusToInput(e), this.change && this.change(n, r), this.input.maxLength > 0 && n.length >= this.input.maxLength && this.next && this.next()
          }
        },
        setFocusToInput: function (t) {
          this.input.focus(), t && this.supportsSelection() && (this.input.selectionStart = t.start, this.input.selectionEnd = t.end)
        }
      },
      mounted: function () {
        this.input && this.setFocusToInput()
      }
    }
  }, function (t, e, n) {
    'use strict'

    function r (t) {
      return t && t.__esModule ? t : {
        default: t
      }
    }
    e.__esModule = !0
    var o = n(6)
    var i = r(o)
    var c = n(57)
    var u = r(c)
    var s = typeof u.default === 'function' && typeof i.default === 'symbol' ? function (t) {
      return typeof t
    } : function (t) {
      return t && typeof u.default === 'function' && t.constructor === u.default && t !== u.default.prototype ? 'symbol' : typeof t
    }
    e.default = typeof u.default === 'function' && s(i.default) === 'symbol' ? function (t) {
      return typeof t === 'undefined' ? 'undefined' : s(t)
    } : function (t) {
      return t && typeof u.default === 'function' && t.constructor === u.default && t !== u.default.prototype ? 'symbol' : typeof t === 'undefined' ? 'undefined' : s(t)
    }
  }, function (t, e, n) {
    t.exports = {
      default: n(7),
      __esModule: !0
    }
  }, function (t, e, n) {
    n(8), n(52), t.exports = n(56).f('iterator')
  }, function (t, e, n) {
    'use strict'
    var r = n(9)(!0)
    n(12)(String, 'String', function (t) {
      this._t = String(t), this._i = 0
    }, function () {
      var t; var e = this._t
      var n = this._i
      return n >= e.length ? {
        value: void 0,
        done: !0
      } : (t = r(e, n), this._i += t.length, {
        value: t,
        done: !1
      })
    })
  }, function (t, e, n) {
    var r = n(10)
    var o = n(11)
    t.exports = function (t) {
      return function (e, n) {
        var i; var c; var u = String(o(e))
        var s = r(n)
        var f = u.length
        return s < 0 || s >= f ? t ? '' : void 0 : (i = u.charCodeAt(s), i < 55296 || i > 56319 || s + 1 === f || (c = u.charCodeAt(s + 1)) < 56320 || c > 57343 ? t ? u.charAt(s) : i : t ? u.slice(s, s + 2) : (i - 55296 << 10) + (c - 56320) + 65536)
      }
    }
  }, function (t, e) {
    var n = Math.ceil
    var r = Math.floor
    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t)
    }
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t)
      return t
    }
  }, function (t, e, n) {
    'use strict'
    var r = n(13)
    var o = n(14)
    var i = n(29)
    var c = n(19)
    var u = n(30)
    var s = n(31)
    var f = n(32)
    var a = n(48)
    var l = n(50)
    var p = n(49)('iterator')
    var h = !([].keys && 'next' in [].keys())
    var y = '@@iterator'
    var d = 'keys'
    var v = 'values'
    var b = function () {
      return this
    }
    t.exports = function (t, e, n, x, g, m, S) {
      f(n, e, x)
      var O; var k; var w; var j = function (t) {
        if (!h && t in C) return C[t]
        switch (t) {
          case d:
            return function () {
              return new n(this, t)
            }
          case v:
            return function () {
              return new n(this, t)
            }
        }
        return function () {
          return new n(this, t)
        }
      }
      var _ = e + ' Iterator'
      var E = g == v
      var P = !1
      var C = t.prototype
      var K = C[p] || C[y] || g && C[g]
      var F = K || j(g)
      var T = g ? E ? j('entries') : F : void 0
      var M = e == 'Array' ? C.entries || K : K
      if (M && (w = l(M.call(new t())), w !== Object.prototype && (a(w, _, !0), r || u(w, p) || c(w, p, b))), E && K && K.name !== v && (P = !0, F = function () {
        return K.call(this)
      }), r && !S || !h && !P && C[p] || c(C, p, F), s[e] = F, s[_] = b, g) {
        if (O = {
          values: E ? F : j(v),
          keys: m ? F : j(d),
          entries: T
        }, S) { for (k in O) k in C || i(C, k, O[k]) } else o(o.P + o.F * (h || P), e, O)
      }
      return O
    }
  }, function (t, e) {
    t.exports = !0
  }, function (t, e, n) {
    var r = n(15)
    var o = n(16)
    var i = n(17)
    var c = n(19)
    var u = 'prototype'
    var s = function (t, e, n) {
      var f; var a; var l; var p = t & s.F
      var h = t & s.G
      var y = t & s.S
      var d = t & s.P
      var v = t & s.B
      var b = t & s.W
      var x = h ? o : o[e] || (o[e] = {})
      var g = x[u]
      var m = h ? r : y ? r[e] : (r[e] || {})[u]
      h && (n = e)
      for (f in n) {
        a = !p && m && void 0 !== m[f], a && f in x || (l = a ? m[f] : n[f], x[f] = h && typeof m[f] !== 'function' ? n[f] : v && a ? i(l, r) : b && m[f] == l ? (function (t) {
          var e = function (e, n, r) {
            if (this instanceof t) {
              switch (arguments.length) {
                case 0:
                  return new t()
                case 1:
                  return new t(e)
                case 2:
                  return new t(e, n)
              }
              return new t(e, n, r)
            }
            return t.apply(this, arguments)
          }
          return e[u] = t[u], e
        }(l)) : d && typeof l === 'function' ? i(Function.call, l) : l, d && ((x.virtual || (x.virtual = {}))[f] = l, t & s.R && g && !g[f] && c(g, f, l)))
      }
    }
    s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s
  }, function (t, e) {
    var n = t.exports = typeof window !== 'undefined' && window.Math == Math ? window : typeof self !== 'undefined' && self.Math == Math ? self : Function('return this')()
    typeof __g === 'number' && (__g = n)
  }, function (t, e) {
    var n = t.exports = {
      version: '2.4.0'
    }
    typeof __e === 'number' && (__e = n)
  }, function (t, e, n) {
    var r = n(18)
    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t
      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n)
          }
        case 2:
          return function (n, r) {
            return t.call(e, n, r)
          }
        case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o)
          }
      }
      return function () {
        return t.apply(e, arguments)
      }
    }
  }, function (t, e) {
    t.exports = function (t) {
      if (typeof t !== 'function') throw TypeError(t + ' is not a function!')
      return t
    }
  }, function (t, e, n) {
    var r = n(20)
    var o = n(28)
    t.exports = n(24) ? function (t, e, n) {
      return r.f(t, e, o(1, n))
    } : function (t, e, n) {
      return t[e] = n, t
    }
  }, function (t, e, n) {
    var r = n(21)
    var o = n(23)
    var i = n(27)
    var c = Object.defineProperty
    e.f = n(24) ? Object.defineProperty : function (t, e, n) {
      if (r(t), e = i(e, !0), r(n), o) {
        try {
          return c(t, e, n)
        } catch (u) {}
      }
      if ('get' in n || 'set' in n) throw TypeError('Accessors not supported!')
      return 'value' in n && (t[e] = n.value), t
    }
  }, function (t, e, n) {
    var r = n(22)
    t.exports = function (t) {
      if (!r(t)) throw TypeError(t + ' is not an object!')
      return t
    }
  }, function (t, e) {
    t.exports = function (t) {
      return typeof t === 'object' ? t !== null : typeof t === 'function'
    }
  }, function (t, e, n) {
    t.exports = !n(24) && !n(25)(function () {
      return Object.defineProperty(n(26)('div'), 'a', {
        get: function () {
          return 7
        }
      }).a != 7
    })
  }, function (t, e, n) {
    t.exports = !n(25)(function () {
      return Object.defineProperty({}, 'a', {
        get: function () {
          return 7
        }
      }).a != 7
    })
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t()
      } catch (e) {
        return !0
      }
    }
  }, function (t, e, n) {
    var r = n(22)
    var o = n(15).document
    var i = r(o) && r(o.createElement)
    t.exports = function (t) {
      return i ? o.createElement(t) : {}
    }
  }, function (t, e, n) {
    var r = n(22)
    t.exports = function (t, e) {
      if (!r(t)) return t
      var n, o
      if (e && typeof (n = t.toString) === 'function' && !r(o = n.call(t))) return o
      if (typeof (n = t.valueOf) === 'function' && !r(o = n.call(t))) return o
      if (!e && typeof (n = t.toString) === 'function' && !r(o = n.call(t))) return o
      throw TypeError("Can't convert object to primitive value")
    }
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      }
    }
  }, function (t, e, n) {
    t.exports = n(19)
  }, function (t, e) {
    var n = {}.hasOwnProperty
    t.exports = function (t, e) {
      return n.call(t, e)
    }
  }, function (t, e) {
    t.exports = {}
  }, function (t, e, n) {
    'use strict'
    var r = n(33)
    var o = n(28)
    var i = n(48)
    var c = {}
    n(19)(c, n(49)('iterator'), function () {
      return this
    }), t.exports = function (t, e, n) {
      t.prototype = r(c, {
        next: o(1, n)
      }), i(t, e + ' Iterator')
    }
  }, function (t, e, n) {
    var r = n(21)
    var o = n(34)
    var i = n(46)
    var c = n(43)('IE_PROTO')
    var u = function () {}
    var s = 'prototype'
    var f = function () {
      var t; var e = n(26)('iframe')
      var r = i.length
      var o = '<'
      var c = '>'
      for (e.style.display = 'none', n(47).appendChild(e), e.src = 'javascript:', t = e.contentWindow.document, t.open(), t.write(o + 'script' + c + 'document.F=Object' + o + '/script' + c), t.close(), f = t.F; r--;) delete f[s][i[r]]
      return f()
    }
    t.exports = Object.create || function (t, e) {
      var n
      return t !== null ? (u[s] = r(t), n = new u(), u[s] = null, n[c] = t) : n = f(), void 0 === e ? n : o(n, e)
    }
  }, function (t, e, n) {
    var r = n(20)
    var o = n(21)
    var i = n(35)
    t.exports = n(24) ? Object.defineProperties : function (t, e) {
      o(t)
      for (var n, c = i(e), u = c.length, s = 0; u > s;) r.f(t, n = c[s++], e[n])
      return t
    }
  }, function (t, e, n) {
    var r = n(36)
    var o = n(46)
    t.exports = Object.keys || function (t) {
      return r(t, o)
    }
  }, function (t, e, n) {
    var r = n(30)
    var o = n(37)
    var i = n(40)(!1)
    var c = n(43)('IE_PROTO')
    t.exports = function (t, e) {
      var n; var u = o(t)
      var s = 0
      var f = []
      for (n in u) n != c && r(u, n) && f.push(n)
      for (; e.length > s;) r(u, n = e[s++]) && (~i(f, n) || f.push(n))
      return f
    }
  }, function (t, e, n) {
    var r = n(38)
    var o = n(11)
    t.exports = function (t) {
      return r(o(t))
    }
  }, function (t, e, n) {
    var r = n(39)
    t.exports = Object('z').propertyIsEnumerable(0) ? Object : function (t) {
      return r(t) == 'String' ? t.split('') : Object(t)
    }
  }, function (t, e) {
    var n = {}.toString
    t.exports = function (t) {
      return n.call(t).slice(8, -1)
    }
  }, function (t, e, n) {
    var r = n(37)
    var o = n(41)
    var i = n(42)
    t.exports = function (t) {
      return function (e, n, c) {
        var u; var s = r(e)
        var f = o(s.length)
        var a = i(c, f)
        if (t && n != n) {
          for (; f > a;) { if (u = s[a++], u != u) return !0 }
        } else {
          for (; f > a; a++) { if ((t || a in s) && s[a] === n) return t || a || 0 }
        }
        return !t && -1
      }
    }
  }, function (t, e, n) {
    var r = n(10)
    var o = Math.min
    t.exports = function (t) {
      return t > 0 ? o(r(t), 9007199254740991) : 0
    }
  }, function (t, e, n) {
    var r = n(10)
    var o = Math.max
    var i = Math.min
    t.exports = function (t, e) {
      return t = r(t), t < 0 ? o(t + e, 0) : i(t, e)
    }
  }, function (t, e, n) {
    var r = n(44)('keys')
    var o = n(45)
    t.exports = function (t) {
      return r[t] || (r[t] = o(t))
    }
  }, function (t, e, n) {
    var r = n(15)
    var o = '__core-js_shared__'
    var i = r[o] || (r[o] = {})
    t.exports = function (t) {
      return i[t] || (i[t] = {})
    }
  }, function (t, e) {
    var n = 0
    var r = Math.random()
    t.exports = function (t) {
      return 'Symbol('.concat(void 0 === t ? '' : t, ')_', (++n + r).toString(36))
    }
  }, function (t, e) {
    t.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',')
  }, function (t, e, n) {
    t.exports = n(15).document && document.documentElement
  }, function (t, e, n) {
    var r = n(20).f
    var o = n(30)
    var i = n(49)('toStringTag')
    t.exports = function (t, e, n) {
      t && !o(t = n ? t : t.prototype, i) && r(t, i, {
        configurable: !0,
        value: e
      })
    }
  }, function (t, e, n) {
    var r = n(44)('wks')
    var o = n(45)
    var i = n(15).Symbol
    var c = typeof i === 'function'
    var u = t.exports = function (t) {
      return r[t] || (r[t] = c && i[t] || (c ? i : o)('Symbol.' + t))
    }
    u.store = r
  }, function (t, e, n) {
    var r = n(30)
    var o = n(51)
    var i = n(43)('IE_PROTO')
    var c = Object.prototype
    t.exports = Object.getPrototypeOf || function (t) {
      return t = o(t), r(t, i) ? t[i] : typeof t.constructor === 'function' && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? c : null
    }
  }, function (t, e, n) {
    var r = n(11)
    t.exports = function (t) {
      return Object(r(t))
    }
  }, function (t, e, n) {
    n(53)
    for (var r = n(15), o = n(19), i = n(31), c = n(49)('toStringTag'), u = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], s = 0; s < 5; s++) {
      var f = u[s]
      var a = r[f]
      var l = a && a.prototype
      l && !l[c] && o(l, c, f), i[f] = i.Array
    }
  }, function (t, e, n) {
    'use strict'
    var r = n(54)
    var o = n(55)
    var i = n(31)
    var c = n(37)
    t.exports = n(12)(Array, 'Array', function (t, e) {
      this._t = c(t), this._i = 0, this._k = e
    }, function () {
      var t = this._t
      var e = this._k
      var n = this._i++
      return !t || n >= t.length ? (this._t = void 0, o(1)) : e == 'keys' ? o(0, n) : e == 'values' ? o(0, t[n]) : o(0, [n, t[n]])
    }, 'values'), i.Arguments = i.Array, r('keys'), r('values'), r('entries')
  }, function (t, e) {
    t.exports = function () {}
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        value: e,
        done: !!t
      }
    }
  }, function (t, e, n) {
    e.f = n(49)
  }, function (t, e, n) {
    t.exports = {
      default: n(58),
      __esModule: !0
    }
  }, function (t, e, n) {
    n(59), n(70), n(71), n(72), t.exports = n(16).Symbol
  }, function (t, e, n) {
    'use strict'
    var r = n(15)
    var o = n(30)
    var i = n(24)
    var c = n(14)
    var u = n(29)
    var s = n(60).KEY
    var f = n(25)
    var a = n(44)
    var l = n(48)
    var p = n(45)
    var h = n(49)
    var y = n(56)
    var d = n(61)
    var v = n(62)
    var b = n(63)
    var x = n(66)
    var g = n(21)
    var m = n(37)
    var S = n(27)
    var O = n(28)
    var k = n(33)
    var w = n(67)
    var j = n(69)
    var _ = n(20)
    var E = n(35)
    var P = j.f
    var C = _.f
    var K = w.f
    var F = r.Symbol
    var T = r.JSON
    var M = T && T.stringify
    var A = 'prototype'
    var L = h('_hidden')
    var I = h('toPrimitive')
    var N = {}.propertyIsEnumerable
    var R = a('symbol-registry')
    var W = a('symbols')
    var z = a('op-symbols')
    var D = Object[A]
    var J = typeof F === 'function'
    var B = r.QObject
    var G = !B || !B[A] || !B[A].findChild
    var V = i && f(function () {
      return k(C({}, 'a', {
        get: function () {
          return C(this, 'a', {
            value: 7
          }).a
        }
      })).a != 7
    }) ? function (t, e, n) {
        var r = P(D, e)
        r && delete D[e], C(t, e, n), r && t !== D && C(D, e, r)
      } : C
    var U = function (t) {
      var e = W[t] = k(F[A])
      return e._k = t, e
    }
    var Y = J && typeof F.iterator === 'symbol' ? function (t) {
      return typeof t === 'symbol'
    } : function (t) {
      return t instanceof F
    }
    var H = function (t, e, n) {
      return t === D && H(z, e, n), g(t), e = S(e, !0), g(n), o(W, e) ? (n.enumerable ? (o(t, L) && t[L][e] && (t[L][e] = !1), n = k(n, {
        enumerable: O(0, !1)
      })) : (o(t, L) || C(t, L, O(1, {})), t[L][e] = !0), V(t, e, n)) : C(t, e, n)
    }
    var Q = function (t, e) {
      g(t)
      for (var n, r = b(e = m(e)), o = 0, i = r.length; i > o;) H(t, n = r[o++], e[n])
      return t
    }
    var X = function (t, e) {
      return void 0 === e ? k(t) : Q(k(t), e)
    }
    var Z = function (t) {
      var e = N.call(this, t = S(t, !0))
      return !(this === D && o(W, t) && !o(z, t)) && (!(e || !o(this, t) || !o(W, t) || o(this, L) && this[L][t]) || e)
    }
    var q = function (t, e) {
      if (t = m(t), e = S(e, !0), t !== D || !o(W, e) || o(z, e)) {
        var n = P(t, e)
        return !n || !o(W, e) || o(t, L) && t[L][e] || (n.enumerable = !0), n
      }
    }
    var $ = function (t) {
      for (var e, n = K(m(t)), r = [], i = 0; n.length > i;) o(W, e = n[i++]) || e == L || e == s || r.push(e)
      return r
    }
    var tt = function (t) {
      for (var e, n = t === D, r = K(n ? z : m(t)), i = [], c = 0; r.length > c;) !o(W, e = r[c++]) || n && !o(D, e) || i.push(W[e])
      return i
    }
    J || (F = function () {
      if (this instanceof F) throw TypeError('Symbol is not a constructor!')
      var t = p(arguments.length > 0 ? arguments[0] : void 0)
      var e = function (n) {
        this === D && e.call(z, n), o(this, L) && o(this[L], t) && (this[L][t] = !1), V(this, t, O(1, n))
      }
      return i && G && V(D, t, {
        configurable: !0,
        set: e
      }), U(t)
    }, u(F[A], 'toString', function () {
      return this._k
    }), j.f = q, _.f = H, n(68).f = w.f = $, n(65).f = Z, n(64).f = tt, i && !n(13) && u(D, 'propertyIsEnumerable', Z, !0), y.f = function (t) {
      return U(h(t))
    }), c(c.G + c.W + c.F * !J, {
      Symbol: F
    })
    for (var et = 'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), nt = 0; et.length > nt;) h(et[nt++])
    for (var et = E(h.store), nt = 0; et.length > nt;) d(et[nt++])
    c(c.S + c.F * !J, 'Symbol', {
      for: function (t) {
        return o(R, t += '') ? R[t] : R[t] = F(t)
      },
      keyFor: function (t) {
        if (Y(t)) return v(R, t)
        throw TypeError(t + ' is not a symbol!')
      },
      useSetter: function () {
        G = !0
      },
      useSimple: function () {
        G = !1
      }
    }), c(c.S + c.F * !J, 'Object', {
      create: X,
      defineProperty: H,
      defineProperties: Q,
      getOwnPropertyDescriptor: q,
      getOwnPropertyNames: $,
      getOwnPropertySymbols: tt
    }), T && c(c.S + c.F * (!J || f(function () {
      var t = F()
      return M([t]) != '[null]' || M({
        a: t
      }) != '{}' || M(Object(t)) != '{}'
    })), 'JSON', {
      stringify: function (t) {
        if (void 0 !== t && !Y(t)) {
          for (var e, n, r = [t], o = 1; arguments.length > o;) r.push(arguments[o++])
          return e = r[1], typeof e === 'function' && (n = e), !n && x(e) || (e = function (t, e) {
            if (n && (e = n.call(this, t, e)), !Y(e)) return e
          }), r[1] = e, M.apply(T, r)
        }
      }
    }), F[A][I] || n(19)(F[A], I, F[A].valueOf), l(F, 'Symbol'), l(Math, 'Math', !0), l(r.JSON, 'JSON', !0)
  }, function (t, e, n) {
    var r = n(45)('meta')
    var o = n(22)
    var i = n(30)
    var c = n(20).f
    var u = 0
    var s = Object.isExtensible || function () {
      return !0
    }
    var f = !n(25)(function () {
      return s(Object.preventExtensions({}))
    })
    var a = function (t) {
      c(t, r, {
        value: {
          i: 'O' + ++u,
          w: {}
        }
      })
    }
    var l = function (t, e) {
      if (!o(t)) return typeof t === 'symbol' ? t : (typeof t === 'string' ? 'S' : 'P') + t
      if (!i(t, r)) {
        if (!s(t)) return 'F'
        if (!e) return 'E'
        a(t)
      }
      return t[r].i
    }
    var p = function (t, e) {
      if (!i(t, r)) {
        if (!s(t)) return !0
        if (!e) return !1
        a(t)
      }
      return t[r].w
    }
    var h = function (t) {
      return f && y.NEED && s(t) && !i(t, r) && a(t), t
    }
    var y = t.exports = {
      KEY: r,
      NEED: !1,
      fastKey: l,
      getWeak: p,
      onFreeze: h
    }
  }, function (t, e, n) {
    var r = n(15)
    var o = n(16)
    var i = n(13)
    var c = n(56)
    var u = n(20).f
    t.exports = function (t) {
      var e = o.Symbol || (o.Symbol = i ? {} : r.Symbol || {})
      t.charAt(0) == '_' || t in e || u(e, t, {
        value: c.f(t)
      })
    }
  }, function (t, e, n) {
    var r = n(35)
    var o = n(37)
    t.exports = function (t, e) {
      for (var n, i = o(t), c = r(i), u = c.length, s = 0; u > s;) { if (i[n = c[s++]] === e) return n }
    }
  }, function (t, e, n) {
    var r = n(35)
    var o = n(64)
    var i = n(65)
    t.exports = function (t) {
      var e = r(t)
      var n = o.f
      if (n) { for (var c, u = n(t), s = i.f, f = 0; u.length > f;) s.call(t, c = u[f++]) && e.push(c) }
      return e
    }
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable
  }, function (t, e, n) {
    var r = n(39)
    t.exports = Array.isArray || function (t) {
      return r(t) == 'Array'
    }
  }, function (t, e, n) {
    var r = n(37)
    var o = n(68).f
    var i = {}.toString
    var c = typeof window === 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : []
    var u = function (t) {
      try {
        return o(t)
      } catch (e) {
        return c.slice()
      }
    }
    t.exports.f = function (t) {
      return c && i.call(t) == '[object Window]' ? u(t) : o(r(t))
    }
  }, function (t, e, n) {
    var r = n(36)
    var o = n(46).concat('length', 'prototype')
    e.f = Object.getOwnPropertyNames || function (t) {
      return r(t, o)
    }
  }, function (t, e, n) {
    var r = n(65)
    var o = n(28)
    var i = n(37)
    var c = n(27)
    var u = n(30)
    var s = n(23)
    var f = Object.getOwnPropertyDescriptor
    e.f = n(24) ? f : function (t, e) {
      if (t = i(t), e = c(e, !0), s) {
        try {
          return f(t, e)
        } catch (n) {}
      }
      if (u(t, e)) return o(!r.f.call(t, e), t[e])
    }
  }, function (t, e) {}, function (t, e, n) {
    n(61)('asyncIterator')
  }, function (t, e, n) {
    n(61)('observable')
  }, function (t, e) {
    'use strict'
    t.exports = {
      normal: {
        _meta: {
          tab: {
            key: '\t',
            text: 'Tab',
            width: 60,
            classes: 'control'
          },
          shiftl: {
            keySet: 'shifted',
            text: 'Shift',
            width: 100,
            classes: 'control'
          },
          shiftr: {
            keySet: 'shifted',
            text: 'Shift',
            width: 100,
            classes: 'control'
          },
          caps: {
            keySet: 'capsed',
            text: 'Caps lock',
            width: 80,
            classes: 'control'
          },
          space: {
            key: ' ',
            text: 'Space',
            width: 180
          },
          enter: {
            key: '\r\n',
            text: 'Enter',
            width: 80,
            classes: 'control'
          },
          backspace: {
            func: 'backspace',
            classes: 'control backspace',
            width: 65
          },
          accept: {
            func: 'accept',
            text: 'Close',
            classes: 'control featured'
          },
          next: {
            func: 'next',
            text: 'Next',
            classes: 'control featured'
          }
        },
        default: ['` 1 2 3 4 5 6 7 8 9 0 - = {backspace}', '{tab} q w e r t y u i o p [ ] \\', "{caps} a s d f g h j k l ; ' {enter}", '{shiftl} z x c v b n m , . / {shiftr}', '{accept} {space} {next}'],
        shifted: ['~ ! @ # $ % ^ & * ( ) _ + {backspace}', '{tab} Q W E R T Y U I O P { } |', '{caps} A S D F G H J K L : " {enter}', '{shiftl} Z X C V B N M < > ? {shiftr}', '{accept} {space} {next}'],
        capsed: ['` 1 2 3 4 5 6 7 8 9 0 - = {backspace}', '{tab} Q W E R T Y U I O P [ ] \\', "{caps} A S D F G H J K L ; ' {enter}", '{shiftl} Z X C V B N M , . / {shiftr}', '{accept} {space} {next}']
      },
      submit: {
        _meta: {
          tab: {
            key: '\t',
            text: 'Tab',
            width: 60,
            classes: 'control'
          },
          shiftl: {
            keySet: 'shifted',
            text: 'Shift',
            width: 100,
            classes: 'control'
          },
          shiftr: {
            keySet: 'shifted',
            text: 'Shift',
            width: 100,
            classes: 'control'
          },
          caps: {
            keySet: 'capsed',
            text: 'Caps lock',
            width: 80,
            classes: 'control'
          },
          space: {
            key: ' ',
            text: 'Space',
            width: 180
          },
          enter: {
            key: '\r\n',
            text: 'Enter',
            width: 80,
            classes: 'control'
          },
          backspace: {
            func: 'backspace',
            classes: 'control backspace',
            width: 65
          },
          accept: {
            func: 'accept',
            text: 'Close',
            classes: 'control featured'
          },
          next: {
            func: 'submit',
            text: 'Submit',
            classes: 'control featured next'
          }
        },
        default: ['` 1 2 3 4 5 6 7 8 9 0 - = {backspace}', '{tab} q w e r t y u i o p [ ] \\', "{caps} a s d f g h j k l ; ' {enter}", '{shiftl} z x c v b n m , . / {shiftr}', '{accept} {space} {next}'],
        shifted: ['~ ! @ # $ % ^ & * ( ) _ + {backspace}', '{tab} Q W E R T Y U I O P { } |', '{caps} A S D F G H J K L : " {enter}', '{shiftl} Z X C V B N M < > ? {shiftr}', '{accept} {space} {next}'],
        capsed: ['` 1 2 3 4 5 6 7 8 9 0 - = {backspace}', '{tab} Q W E R T Y U I O P [ ] \\', "{caps} A S D F G H J K L ; ' {enter}", '{shiftl} Z X C V B N M , . / {shiftr}', '{accept} {space} {next}']
      },
      email: {
        _meta: {
          tab: {
            key: '\t',
            text: 'Tab',
            width: 60,
            classes: 'control'
          },
          shiftl: {
            keySet: 'shifted',
            text: 'Shift',
            width: 100,
            classes: 'control'
          },
          shiftr: {
            keySet: 'shifted',
            text: 'Shift',
            width: 100,
            classes: 'control'
          },
          caps: {
            keySet: 'capsed',
            text: 'Caps lock',
            width: 80,
            classes: 'control'
          },
          space: {
            key: ' ',
            text: 'Space',
            width: 180
          },
          enter: {
            key: '\r\n',
            text: 'Enter',
            width: 80,
            classes: 'control'
          },
          backspace: {
            func: 'backspace',
            classes: 'control backspace',
            width: 65
          },
          accept: {
            func: 'accept',
            text: 'Close',
            classes: 'control featured'
          },
          next: {
            func: 'next',
            text: 'Next',
            classes: 'control featured'
          }
        },
        default: ['` 1 2 3 4 5 6 7 8 9 0 - = {backspace}', '{tab} q w e r t y u i o p [ ] \\', "{caps} a s d f g h j k l ; ' {enter}", '{shiftl} z x c v b n m , . / {shiftr}', '{accept} @ {space} .com {next}'],
        shifted: ['~ ! @ # $ % ^ & * ( ) _ + {backspace}', '{tab} Q W E R T Y U I O P { } |', '{caps} A S D F G H J K L : " {enter}', '{shiftl} Z X C V B N M < > ? {shiftr}', '{accept} @ {space} .com {next}'],
        capsed: ['` 1 2 3 4 5 6 7 8 9 0 - = {backspace}', '{tab} Q W E R T Y U I O P [ ] \\', "{caps} A S D F G H J K L ; ' {enter}", '{shiftl} Z X C V B N M , . / {shiftr}', '{accept} @ {space} .com {next}']
      },
      compact: {
        _meta: {
          default: {
            keySet: 'default',
            text: 'abc',
            classes: 'control'
          },
          alpha: {
            keySet: 'default',
            text: 'Abc',
            classes: 'control'
          },
          shift: {
            keySet: 'shifted',
            text: 'ABC',
            classes: 'control'
          },
          numbers: {
            keySet: 'numbers',
            text: '123',
            classes: 'control'
          },
          space: {
            key: ' ',
            text: 'Space',
            width: 200
          },
          backspace: {
            func: 'backspace',
            classes: 'control'
          },
          accept: {
            func: 'accept',
            text: 'Close',
            classes: 'control featured'
          },
          next: {
            func: 'next',
            text: 'Next',
            classes: 'featured'
          },
          zero: {
            key: '0',
            width: 130
          }
        },
        default: ['q w e r t y u i o p', ' a s d f g h j k l ', '{shift} z x c v b n m {backspace}', '{numbers} , {space} . {accept} {next}'],
        shifted: ['Q W E R T Y U I O P', ' A S D F G H J K L ', '{default} Z X C V B N M ', '{numbers} _ {space} {backspace} {accept} {next}'],
        numbers: ['1 2 3', '4 5 6', '7 8 9', '  {alpha} . {zero} {backspace} {accept} {next}']
      },
      numeric: {
        _meta: {
          backspace: {
            func: 'backspace',
            classes: 'control'
          },
          accept: {
            func: 'accept',
            text: 'Close',
            classes: 'control featured'
          },
          next: {
            func: 'next',
            text: 'Next',
            classes: 'control featured'
          },
          zero: {
            key: '0',
            width: 82
          }
        },
        default: ['1 2 3', '4 5 6', '7 8 9', '{accept} . {zero} {backspace} {next}']
      },
      phone: {
        _meta: {
          backspace: {
            func: 'backspace_custom',
            classes: 'control backspace'
          },
          accept: {
            func: 'accept',
            text: 'Close',
            classes: 'control featured'
          },
          next: {
            func: 'next',
            text: 'Next',
            classes: 'control featured'
          },
          zero: {
            key: '0',
            width: 82
          }
        },
        default: ['1 2 3', '4 5 6', '7 8 9', '{accept} . {zero} {backspace} {next}']
      },
      submit_phone: {
        _meta: {
          backspace: {
            func: 'backspace_custom',
            classes: 'control backspace'
          },
          accept: {
            func: 'accept',
            text: 'Close',
            classes: 'control featured'
          },
          next: {
            func: 'submit',
            text: 'Submit',
            classes: 'control featured next'
          },
          zero: {
            key: '0',
            width: 82
          }
        },
        default: ['1 2 3', '4 5 6', '7 8 9', '{accept} . {zero} {backspace} {next}']
      }
    }
  }, function (t, e, n) {
    function r (t) {
      return typeof t === 'string' || !i(t) && c(t) && o(t) == u
    }
    var o = n(75)
    var i = n(81)
    var c = n(82)
    var u = '[object String]'
    t.exports = r
  }, function (t, e, n) {
    function r (t) {
      return t == null ? void 0 === t ? s : u : f && f in Object(t) ? i(t) : c(t)
    }
    var o = n(76)
    var i = n(79)
    var c = n(80)
    var u = '[object Null]'
    var s = '[object Undefined]'
    var f = o ? o.toStringTag : void 0
    t.exports = r
  }, function (t, e, n) {
    var r = n(77)
    var o = r.Symbol
    t.exports = o
  }, function (t, e, n) {
    var r = n(78)
    var o = typeof self === 'object' && self && self.Object === Object && self
    var i = r || o || Function('return this')()
    t.exports = i
  }, function (t, e) {
    (function (e) {
      var n = typeof e === 'object' && e && e.Object === Object && e
      t.exports = n
    }).call(e, (function () {
      return this
    }()))
  }, function (t, e, n) {
    function r (t) {
      var e = c.call(t, s)
      var n = t[s]
      try {
        t[s] = void 0
        var r = !0
      } catch (o) {}
      var i = u.call(t)
      return r && (e ? t[s] = n : delete t[s]), i
    }
    var o = n(76)
    var i = Object.prototype
    var c = i.hasOwnProperty
    var u = i.toString
    var s = o ? o.toStringTag : void 0
    t.exports = r
  }, function (t, e) {
    function n (t) {
      return o.call(t)
    }
    var r = Object.prototype
    var o = r.toString
    t.exports = n
  }, function (t, e) {
    var n = Array.isArray
    t.exports = n
  }, function (t, e) {
    function n (t) {
      return t != null && typeof t === 'object'
    }
    t.exports = n
  }, function (t, e) {
    function n (t) {
      var e = typeof t
      return t != null && (e == 'object' || e == 'function')
    }
    t.exports = n
  }, function (t, e) {
    t.exports = {
      render: function () {
        var t = this
        var e = t.$createElement
        var n = t._self._c || e
        return n('div', {
          staticClass: 'vue-touch-keyboard'
        }, [n('div', {
          staticClass: 'keyboard'
        }, t._l(t.keySet, function (e, r) {
          return n('div', {
            key: 'index',
            staticClass: 'line'
          }, t._l(e, function (e, r) {
            return n('span', {
              key: 'index',
              class: t.getClassesOfKey(e),
              style: t.getKeyStyle(e),
              domProps: {
                textContent: t._s(t.getCaptionOfKey(e))
              },
              on: {
                click: function (n) {
                  t.clickKey(e)
                },
                mousedown: t.mousedown
              }
            })
          }))
        }))])
      },
      staticRenderFns: []
    }
  }]))
}))
